const generalActionTypes = {
  FETCH_CAMPAIGNS_INSIGHTS: 'FETCH_CAMPAIGNS_INSIGHTS',
  FETCH_CAMPAIGNS_INSIGHTS_SUCCESS: 'FETCH_CAMPAIGNS_INSIGHTS_SUCCESS',
  FETCH_CAMPAIGNS_INSIGHTS_FAIL: 'FETCH_CAMPAIGNS_INSIGHTS_FAIL',
};

export default generalActionTypes;
